/**
 * Created by joellee on 12/3/15.
 */
commonModule.factory('singleInstanceService', ['AppSettings', '$interval',
    function (appSettings, $interval) {
        var api = {};

        // Use "tlc" name space when connecting
        var socketServerUrl = appSettings.socketServerUrl + "tlc";
        var socket = null;

        function show(msg, data) {
            // diagnostic
            console.log('socket ' + msg);
            if (data) {
                console.log(data);
            }
        }

        api.shutdownPriorInstance = function(channel)
        {
            socket = io.connect(socketServerUrl, { transports: ['websocket'] }); // no xhr long-polling or JSONP!

            socket.on('connect', function (data) {
                show('connect', data);
                // close any previously opened TLC UI instances for this channel (= menu session)
                // then join the channel (server side) so we can be notified by future TLC instances using channel
                socket.emit('shutdown_prior', { channel: channel});
            });

            // now listen for any future requests to shut down this instance
            socket.on('remote_shutdown_requested', function(data) {
                show('remote_shutdown_requested', data);
                if (!data || data.channel != channel) {
                    // Defensive. This should never happen.
                    console.log('ignored because channel is incorrect');
                    return;
                }

                console.log('closing window');
                window.close();
                $interval(function () {
                    // Interval 0 is for IE, which closes window *after* function that calls window.close finishes execution
                    // We should never get to this point.
                    console.error('window close failed!')
                }, 0);

            });

            // diagnostic only, happens  rarely
            ['disconnect', 'reconnecting', 'reconnect_attempt', 'reconnect_error', 'reconnect_failed']
            .forEach(function(eventName) {
               socket.on(eventName, function(data) { show(eventName, data)});
            });


        };

        return api;
    }]);